import { addCourseToCandidate } from "./addCourseToCandidate";
import { addEducationToCandidate } from "./addEducationToCandidate";
import { addExperienceToCandidate } from "./addExperienceToCandidate";
import { addGeoWishFromCandidate } from "./addGeoWishToCandidate";
import { addKnowledgeToCandidate } from "./addKnowledgeToCandidate";
import { addPositionWishToCandidate } from "./addPositionWishToCandidate";
import { addPwaToken } from "./addPwaToken";
import { applyWithProfile } from "./applyWithProfile";
import { applyWithProfileMultiAttachements } from "./applyWithProfileMultiAttachments";
import { applyWithoutProfile } from "./applyWithoutProfile";
import { applyWithoutProfileMultiAttachments } from "./applyWithoutProfileMultiAttachments";
import { checkWasDeleteRequested } from "./checkWasDeleteRequested";
import { deleteMe } from "./deleteMe";
import { deleteProfilePicture } from "./deleteProfilePicture";
import { detachCandidateFromCase } from "./detachCandidateFromCase";
import { editCourseForCandidate } from "./editCourseForCandidate";
import { editEducationForCandidate } from "./editEducationForCandidate";
import { editExperienceForCandidate } from "./editExperienceForCandidate";
import { editKnowledgeForCandidate } from "./editKnowledgeForCandidate";
import { editPositionWishForCandidate } from "./editPositionWishForCandidate";
import { emulateEmailPendingLinkClick } from "./emulateEmailPendingLinkClick";
import { endConsentForCandidate } from "./endConsent";
import { getAllConsents } from "./getConsentAllConsents";
import { getConsentForCandidate } from "./getConsentSummaryForCandidate";
import { getCoursesForCandidate } from "./getCoursesForCandidate";
import { getDetailsForCandidate } from "./getDetailsForCandidate";
import { getEducationForCandidate } from "./getEducationForCandidate";
import { getExperienceForCandidate } from "./getExperienceForCandidate";
import { getGeoWishes } from "./getGeoWishes";
import { getKnowledgeForCandidate } from "./getKnowledgeForCandidate";
import { getPositionWishes } from "./getPositionWishes";
import { getPositionWishesFromCandidateObj } from "./getPositionWishesFromCandidateObj";
import { getPrivacyStatement } from "./getPrivacyStatement";
import { getProfilePictureUrl } from "./getProfilePictureUrl";
import { isCandidateAttachedToCase } from "./isCandidateAttachedToCase";
import { quickConsentCheckForCandidate } from "./quickConsentCheckForCandidate";
import { removeCourseFromCandidate } from "./removeCourseFromCandidate";
import { removeEducationFromCandidate } from "./removeEducationFromCandidate";
import { removeExperienceFromCandidate } from "./removeExperienceFromCandidate";
import { removeGeoWishFromCandidate } from "./removeGeoWishToCandidate";
import { removeKnowledgeByTypeFromCandidate } from "./removeKnowledgeByTypeFromCandidate";
import { removeKnowledgeFromCandidate } from "./removeKnowledgeFromCandidate";
import { removePositionWishFromCandidate } from "./removePositionWishToCandidate";
import { setCandidateLanguage } from "./setCandidateLanguage";
import { setGeoWishToCandidate } from "./setGeoWishToCandidate";
import { setKnowledgeForCandidate } from "./setKnowledgeForCandidate";
import { setPositionWishToCandidate } from "./setPositionWishToCandidate";
import { startConsentForCandidate } from "./startConsent";
import { updateCandidate } from "./updateCandidate";
import { uploadProfilePicture } from "./uploadProfilePicture";

export const candidateAPI = {
  addCourseToCandidate,
  getCoursesForCandidate,
  removeCourseFromCandidate,
  addEducationToCandidate,
  getEducationForCandidate,
  removeEducationFromCandidate,
  addExperienceToCandidate,
  getExperienceForCandidate,
  removeExperienceFromCandidate,
  addKnowledgeToCandidate,
  getKnowledgeForCandidate,
  removeKnowledgeFromCandidate,
  removeKnowledgeByTypeFromCandidate,
  updateCandidate,
  getDetailsForCandidate,
  addPositionWishToCandidate,
  getProfilePictureUrl,
  deleteProfilePicture,
  uploadProfilePicture,
  removePositionWishFromCandidate,
  editExperienceForCandidate,
  editCourseForCandidate,
  editEducationForCandidate,
  editKnowledgeForCandidate,
  editPositionWishForCandidate,
  applyWithProfile,
  getConsentForCandidate,
  startConsentForCandidate,
  endConsentForCandidate,
  getAllConsents,
  getPrivacyStatement,
  deleteMe,
  checkWasDeleteRequested,
  getPositionWishes,
  getGeoWishes,
  addGeoWishFromCandidate,
  removeGeoWishFromCandidate,
  getPositionWishesFromCandidateObj,
  setGeoWishToCandidate,
  setPositionWishToCandidate,
  setKnowledgeForCandidate,
  setCandidateLanguage,
  isCandidateAttachedToCase,
  detachCandidateFromCase,
  applyWithoutProfile,
  quickConsentCheckForCandidate,
  applyWithProfileMultiAttachements,
  applyWithoutProfileMultiAttachments,
  emulateEmailPendingLinkClick,
  addPwaToken,
};

export type CandidateAPI = typeof candidateAPI;
